module.exports = __webpack_public_path__ + "img/success.e581f530.png";